/**
 * @prettier
 */

import CustomizeButton from './CustomizeButton';
import MaxSamplesHint from './MaxSamplesHint';
import PLPTile from './PLPTile';
import Toggle from './Toggle';
import { ToggleLabel } from './ToggleLabel';

export default {
  CustomizeButton,
  MaxSamplesHint,
  PLPTile,
  Toggle,
  ToggleLabel,
};
